import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import getTranslation from '../../util/Language';
import { handleClearCache } from '../handleClearCache';
import styles from './ClearCacheButton.module.scss';

const ClearCacheButton = ({ isErrorBoundaryBtn }) => {
    const [show, setShow] = useState(isErrorBoundaryBtn);

    useEffect(() => {
        if (!isErrorBoundaryBtn) {
            const timeout = setTimeout(() => {
                setShow(true);
            }, 15_000);
            return () => clearTimeout(timeout);
        }
    }, [isErrorBoundaryBtn]);

    if (!show) return null;
    return (
        <Button id={styles.clearCacheButton} onClick={handleClearCache}>
            <FontAwesomeIcon icon={faRedo} className='mr-2' />
            {getTranslation('shared.reload')}
        </Button>
    );
};

export default ClearCacheButton;
